import React, { useEffect, useState } from 'react';

import ReactMarkdown from 'react-markdown';
import { rehypeDom } from 'rehype-dom';
import rehypeExternalLinks from 'rehype-external-links';
import rehypeSanitize from 'rehype-sanitize';

interface TFMarkdownTextProps {
	text: string;
	className?: string;
}

export const TFMarkdownText: React.FC<TFMarkdownTextProps> = ({ text, className }) => {
	return (
		<ReactMarkdown linkTarget="_blank" className={className}>
			{text}
		</ReactMarkdown>
	);
};

export const TFHTMLText: React.FC<TFMarkdownTextProps> = ({ text, className }) => {
	const [cleanHTML, setCleanHTML] = useState('');

	useEffect(() => {
		const process = async () => {
			const processedHtml = await rehypeDom()
				.use(rehypeSanitize)
				.use(rehypeExternalLinks, { target: '_blank' })
				.process(text);

			setCleanHTML(String(processedHtml));
		};

		process();
	}, [text]);

	return <div className={className} dangerouslySetInnerHTML={{ __html: cleanHTML }}></div>;
};
